import { HTMLAttributes } from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";

import { wacToken } from "@/libraries/design/foundations/index.ts";

export const SectionHeader = (props: HTMLAttributes<HTMLTableRowElement>) => {
    return <tr {...props} css={sectionHeaderCss} />;
};

export interface SectionHeaderCellProps
    extends HTMLAttributes<HTMLTableCellElement> {
    colSpan?: number;
    id?: string;
    scope?: string;
}

export const SectionHeaderCell = (props: SectionHeaderCellProps) => {
    const { scope = "rowgroup", ...rest } = props;
    return <th {...rest} scope={scope} css={sectionHeaderCellCss} />;
};

const sectionHeaderCss = css({
    color: wacToken("color.primary.black"),
    flexDirection: "column",
    margin: "16px 0",
    backgroundColor: wacToken("color.neutral.light100"),
    transition: "background-color .5s",
    padding: 0,
    textAlign: "center",
    [media.below.sm]: {
        display: "none"
    }
});

const sectionHeaderCellCss = css({
    "justifyContent": "space-between",
    "fontWeight": 400,
    "textAlign": "left",
    "color": wacToken("color.primary.black"),
    [media.below.sm]: {
        display: "flex",
        padding: "12px 14px"
    },
    "display": "table-cell",
    "padding": "14px",
    "borderInlineEnd": `1px solid ${wacToken("color.neutral.light400")}`,
    ":last-of-type": {
        borderInlineEnd: "none"
    }
});
